import React from 'react';
import logo from '../assets/analytiq.png';
import './KioskBranding.css';

export default function KioskBranding() {
  return (
    <div className="k-platform">
      <span className="k-platform__label">Powered by</span>
      <img className="k-platform__logo" src={logo} alt="AnalytiQ" />
    </div>
  );
}
